import * as React from 'react';
import { useMemo } from 'react';
import { BaggageItemDirection } from '../../types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';

interface Props {
	directions: BaggageItemDirection[];
	className?: string;
	allSegments?: boolean;
}

const BaggageDirection: React.FC<Props> = ({ directions, allSegments, className }) => {
	const { BaggageDirection: css } = useTheme('BaggageList');
	const { t } = useTranslation('IncludedBaggage');

	const text = useMemo(() => {
		if (allSegments) {
			return t('All flights');
		}

		return directions.map(point => `${point.departure.iata} - ${point.arrival.iata}`).join('; ');
	}, [directions]);

	if (text === null) {
		return null;
	}

	return <span className={cn(css.root, className)}>{text}</span>;
};

export default BaggageDirection;
